import { createFileRoute } from '@tanstack/react-router';
import { PersonRecord } from '@/admin/people/PersonRecord';

export const Route = createFileRoute('/admin/people/$userId')({
  staticData: { minTier: 'FRONT_END_SUPPORT' },
  // `?dialog=delete` opens the deletion dialog on arrival: the front sidebar's
  // Delete links here.
  validateSearch: (s: Record<string, unknown>): { dialog?: 'delete' } => ({
    dialog: s.dialog === 'delete' ? 'delete' : undefined,
  }),
  component: Person,
});

function Person() {
  const { userId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <PersonRecord
      userId={Number(userId)}
      openDelete={search.dialog === 'delete'}
    />
  );
}
